/*
 * The actions a custom role may grant (VIS-332), each with the catalogue keys
 * of its area heading and its label. Identity decides which actions are
 * grantable; an entry is added here when Identity marks its action grantable.
 * The role editor offers only the entries the caller holds.
 */
export type GrantableAction = { id: string; areaKey: string; labelKey: string }

export const GRANTABLE_ACTIONS: GrantableAction[] = [
  { id: 'guests.view', areaKey: 'core.nav.guests', labelKey: 'people.actions.guestsView' },
  { id: 'guests.contact_details.view', areaKey: 'core.nav.guests', labelKey: 'people.actions.guestsContactDetails' },
  { id: 'guests.diagnostics.view', areaKey: 'core.nav.guests', labelKey: 'people.actions.guestsDiagnostics' },
]
